(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subellotti-clothing-rail"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('subellotti-rail')){
customElements.define('subellotti-rail',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.track=this.querySelector('.sb-rail__track');const originals=Array.from(this.track.children);this.count=originals.length;if(!this.count)return;
this.reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;this.paused=this.reduced;this.hovered=false;this.focused=false;this.visible=false;
const before=document.createDocumentFragment(),after=document.createDocumentFragment();
originals.forEach((item,index)=>{item.dataset.productIndex=index;item.dataset.copy='1';for(const [copy,fragment] of [[0,before],[2,after]]){const clone=item.cloneNode(true);clone.dataset.copy=copy;clone.setAttribute('aria-hidden','true');clone.querySelectorAll('button,a').forEach(control=>control.tabIndex=-1);fragment.appendChild(clone);}});
this.track.prepend(before);this.track.appendChild(after);this.items=Array.from(this.track.children);this.selected=this.count;
this.playButton=this.querySelector('[data-play]');this.updatePlay();this.playButton.addEventListener('click',()=>{this.paused=!this.paused;this.updatePlay();});
this.track.addEventListener('pointerenter',()=>{if(matchMedia('(hover:hover)').matches)this.hovered=true;});this.track.addEventListener('pointerleave',()=>{this.hovered=false;});
this.track.addEventListener('focusin',()=>{this.focused=true;});this.track.addEventListener('focusout',event=>{this.focused=this.track.contains(event.relatedTarget);});
this.track.addEventListener('scroll',()=>{clearTimeout(this.scrollTimer);if(this.animating||this.zoomOpen)return;this.scrollTimer=setTimeout(()=>{if(this.animating||this.touching||this.zoomOpen)return;const center=this.track.scrollLeft+this.track.clientWidth/2;let nearest=this.selected,distance=Infinity;this.items.forEach((item,index)=>{const delta=Math.abs(item.offsetLeft+item.clientWidth/2-center);if(delta<distance){distance=delta;nearest=index;}});if(nearest!==this.selected)this.select(nearest,true);},180);},{passive:true});
this.track.addEventListener('pointerdown',event=>{if(!event.isPrimary||event.button!==0)return;this.touching=true;this.dragStart={id:event.pointerId,x:event.clientX,y:event.clientY,scroll:this.track.scrollLeft,moved:false};});
this.track.addEventListener('pointermove',event=>{if(this.dragStart?.id===event.pointerId&&Math.hypot(event.clientX-this.dragStart.x,event.clientY-this.dragStart.y)>10)this.dragStart.moved=true;},{passive:true});
this.release=event=>{if(!this.dragStart||this.dragStart.id!==event.pointerId)return;this.touching=false;const moved=this.dragStart.moved||Math.abs(this.track.scrollLeft-this.dragStart.scroll)>14||Math.hypot(event.clientX-this.dragStart.x,event.clientY-this.dragStart.y)>10||event.type==='pointercancel';if(moved)this.suppressClickUntil=performance.now()+350;this.dragStart=null;};window.addEventListener('pointerup',this.release);window.addEventListener('pointercancel',this.release);
this.track.addEventListener('click',event=>{if(event.detail!==0&&performance.now()<(this.suppressClickUntil||0)){event.preventDefault();event.stopPropagation();return;}const item=event.target.closest('.sb-rail__item');if(!item)return;const view=event.target.closest('[data-view]');if(view){this.showView(item.dataset.productIndex,view.dataset.view);}else if(event.target.closest('.sb-rail__select')){this.paused=true;this.updatePlay();this.select(this.items.indexOf(item),true);if(event.detail!==0){const control=item.querySelector('.sb-rail__select');control.classList.add('is-pointer-return');control.blur();}}});
this.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{if(!this.animating&&!this.zoomOpen)this.select(this.selected+Number(button.dataset.step),true);}));
this.track.addEventListener('keydown',event=>{this.track.querySelectorAll('.is-pointer-return').forEach(control=>control.classList.remove('is-pointer-return'));if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const logical=Number(this.items[this.selected].dataset.productIndex);const index=event.key==='Home'?0:event.key==='End'?this.count-1:(logical+(event.key==='ArrowRight'?1:-1)+this.count)%this.count;this.select(this.count+index,true);this.items[this.count+index].querySelector('.sb-rail__select').focus({preventScroll:true});});
this.dialog=this.querySelector('.sb-rail__zoom');this.dialog.querySelector('[data-close]').addEventListener('click',()=>this.closeZoom());
this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.closeZoom();});
this.dialog.addEventListener('click',event=>{const view=event.target.closest('[data-view]');if(view&&this.zoomCard)this.showView(this.zoomCard.dataset.productIndex,view.dataset.view);else if(event.target===this.dialog)this.closeZoom();});
this.dialog.addEventListener('close',()=>{this.zoomOpen=false;this.classList.remove('is-zoomed');document.body.style.overflow=this.previousBodyOverflow??'';const opener=this.zoomSource?.querySelector('.sb-rail__select');if(opener){opener.classList.toggle('is-pointer-return',!this.zoomKeyboard);if(this.zoomKeyboard)opener.focus({preventScroll:true});else opener.blur();}this.zoomCard=null;this.center();});
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:.1});this.observer.observe(this);
this.trackWidth=this.track.clientWidth;this.resizeObserver=new ResizeObserver(()=>{const width=this.track.clientWidth;if(width!==this.trackWidth){this.trackWidth=width;if(!this.animating&&!this.zoomOpen)this.center();}});this.resizeObserver.observe(this.track);
this.select(this.count,false);
this.interval=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.focused&&!this.touching&&this.visible&&!document.hidden&&!this.animating&&!this.zoomOpen)this.select(this.selected+1,true);},4200);
}
setView(card,view){
if(view==='front'&&!card.querySelector('.sb-rail__image:not(.sb-rail__image--back):not(.sb-rail__image--right)'))view=card.querySelector('.sb-rail__image--back')?'back':'right';
if(!card.querySelector(`[data-view="${view}"]`)&&view!=='front')return;
card.querySelectorAll('.sb-rail__image').forEach(image=>{const angle=image.classList.contains('sb-rail__image--back')?'back':image.classList.contains('sb-rail__image--right')?'right':'front';image.hidden=angle!==view;});
card.querySelectorAll('[data-view]').forEach(control=>control.setAttribute('aria-pressed',String(control.dataset.view===view)));
}
showView(index,view){this.items.filter(card=>card.dataset.productIndex===String(index)).forEach(card=>this.setView(card,view));if(this.zoomCard?.dataset.productIndex===String(index))this.setView(this.zoomCard,view);}
openZoom(item,event){
if(this.zoomOpen)return;this.zoomKeyboard=event?.detail===0&&!event?.pointerType;this.zoomOpen=true;this.zoomSource=item;this.zoomSourceRect=item.querySelector('.sb-rail__garment').getBoundingClientRect();
this.zoomCard=document.createElement('div');this.zoomCard.className='sb-rail__zoom-card';this.zoomCard.dataset.productIndex=item.dataset.productIndex;
this.zoomCard.append(item.querySelector('.sb-rail__garment').cloneNode(true),item.querySelector('.sb-rail__details').cloneNode(true));
this.zoomCard.querySelectorAll('[tabindex]').forEach(control=>control.removeAttribute('tabindex'));
this.dialog.querySelector('.sb-rail__zoom-content').replaceChildren(this.zoomCard);this.dialog.setAttribute('aria-label',item.querySelector('h3').textContent);
this.previousBodyOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.classList.add('is-zoomed');
const spriteHeight=this.zoomCard.querySelector('.sb-rail__garment').clientHeight;this.zoomCard.querySelectorAll('[data-sprite-ratio]').forEach(image=>{image.sizes=`${Math.ceil(spriteHeight*Number(image.dataset.spriteRatio))}px`;});
const hero=this.zoomCard.querySelector('.sb-rail__garment'),end=hero.getBoundingClientRect(),start=this.zoomSourceRect;
this.zoomTransform=`translate(${start.left+start.width/2-end.left-end.width/2}px,${start.top+start.height/2-end.top-end.height/2}px) scale(${start.width/end.width},${start.height/end.height})`;
if(!this.reduced){hero.animate([{transform:this.zoomTransform,opacity:.65},{transform:'none',opacity:1}],{duration:650,easing:'cubic-bezier(.22,.61,.36,1)'});this.zoomCard.querySelector('.sb-rail__details').animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:500,delay:180,fill:'backwards'});}
}
async closeZoom(){
if(!this.zoomOpen||this.closing)return;this.closing=true;
if(!this.reduced&&this.zoomCard){const hero=this.zoomCard.querySelector('.sb-rail__garment'),start=hero.getBoundingClientRect(),end=this.zoomSource.querySelector('.sb-rail__garment').getBoundingClientRect();const transform=`translate(${end.left+end.width/2-start.left-start.width/2}px,${end.top+end.height/2-start.top-start.height/2}px) scale(${end.width/start.width},${end.height/start.height})`;this.zoomCard.querySelector('.sb-rail__details').style.opacity='0';await hero.animate([{transform:'none',opacity:1},{transform,opacity:.5}],{duration:450,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'}).finished.catch(()=>{});}
this.dialog.close();this.closing=false;
}
updatePlay(){this.playButton.textContent=this.paused?'▶':'Ⅱ';this.playButton.setAttribute('aria-label',this.paused?this.playButton.dataset.playLabel:this.playButton.dataset.pauseLabel);this.querySelector('.sb-rail__count').setAttribute('aria-live',this.paused?'polite':'off');}
center(){const item=this.items[this.selected];this.track.scrollLeft=item.offsetLeft-(this.track.clientWidth-item.clientWidth)/2;}
select(index,animate,move=true){
if(!this.items[index])return;if(animate&&!this.reduced){this.track.classList.remove('is-swaying');void this.track.offsetWidth;this.track.classList.add('is-swaying');}cancelAnimationFrame(this.frame);const previous=this.items[this.selected];this.selected=index;
if(previous&&previous.dataset.productIndex!==this.items[index].dataset.productIndex)this.showView(previous.dataset.productIndex,previous.querySelector('.sb-rail__image--right')?'right':'front');
if(!previous||!previous.classList.contains('is-selected')||previous.dataset.productIndex!==this.items[index].dataset.productIndex)this.showView(this.items[index].dataset.productIndex,'front');
this.items.forEach((item,i)=>{const active=i===index;item.classList.toggle('is-selected',active);item.classList.toggle('is-before',i<index);item.querySelector('.sb-rail__select').setAttribute('aria-pressed',String(active));});
this.querySelector('.sb-rail__count').textContent=(Number(this.items[index].dataset.productIndex)+1)+' / '+this.count;
if(!move){this.animating=false;return;}
const start=this.track.scrollLeft,duration=animate&&!this.reduced?760:0,began=performance.now();this.animating=duration>0;
const update=time=>{const progress=duration?Math.min((time-began)/duration,1):1,easing=1-Math.pow(1-progress,3),item=this.items[index],target=item.offsetLeft-(this.track.clientWidth-item.clientWidth)/2;this.track.scrollLeft=start+(target-start)*easing;if(progress<1)this.frame=requestAnimationFrame(update);else{this.animating=false;this.normalize();}};
if(duration)this.frame=requestAnimationFrame(update);else{this.center();this.animating=false;this.normalize();}
}
normalize(){const item=this.items[this.selected];if(item.dataset.copy==='1')return;this.classList.add('is-resetting');this.selected=this.count+Number(item.dataset.productIndex);this.items.forEach((card,i)=>{const active=i===this.selected;card.classList.toggle('is-selected',active);card.classList.toggle('is-before',i<this.selected);card.querySelector('.sb-rail__select').setAttribute('aria-pressed',String(active));});this.center();this.frame=requestAnimationFrame(()=>this.classList.remove('is-resetting'));}
disconnectedCallback(){if(this.dialog?.open)this.dialog.close();clearInterval(this.interval);clearTimeout(this.scrollTimer);cancelAnimationFrame(this.frame);this.observer?.disconnect();this.resizeObserver?.disconnect();window.removeEventListener('pointerup',this.release);window.removeEventListener('pointercancel',this.release);}
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subellotti-mtm-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selection = document.querySelector('[data-mtm-selection]');
    if (!selection) return;

    const params = new URLSearchParams(window.location.search);
    const handle = params.get('product');
    const title = params.get('title');
    const variant = params.get('variant') || params.get('variant_id');
    const image = params.get('image');
    if (!handle || !title || !/^[a-z0-9-]+$/.test(handle)) return;

    selection.querySelector('[data-mtm-product-title]').textContent = title;
    selection.querySelector('[data-mtm-variant-id]').textContent = variant || '—';

    const productImage = selection.querySelector('[data-mtm-product-image]');
    if (image && /^https:\/\/(?:cdn\.shopify\.com|subellotti\.com)\//.test(image.startsWith('//') ? `https:${image}` : image)) {
      productImage.src = image.startsWith('//') ? `https:${image}` : image;
      productImage.alt = title;
    } else {
      productImage.closest('.sb-mtm__selection-image').hidden = true;
    }

    const returnLink = selection.querySelector('[data-mtm-return-link]');
    returnLink.href = `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}${variant ? `?variant=${encodeURIComponent(variant)}` : ''}`;
    selection.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();
})();
